import React from 'react';
import { useTranslation } from 'react-i18next';

import full from '../../img/materials/full.jpg';
import conditional from '../../img/materials/conditional.jpg';
import none from '../../img/materials/none.jpg';

const MaterialsLegend = () => {
  
  const { t, i18n } = useTranslation()
  const lang = i18n.language

  return (
    <div className="materials-legend">
      <span className="title">{t("Intended materials legend")}</span>
        <ul>
          <li><img src={full} alt="" /> {t("Secure attachment")}</li>
          <li><img src={conditional} alt="" /> {t("After checking the attachment")}</li>
          <li><img src={none} alt="" /> {t("Not intended for")}</li>
        </ul>
    </div>
  );
}

export default MaterialsLegend;
